import { z } from "zod";

import moment from "moment";

import { Command } from "../../types";

export const resetUserTaxCaseSchema = z.object({
  command: z.literal(Command.ResetUserTaxCase),
  date: z.custom<moment.Moment>((value) => moment.isMoment(value), {
    message: "Please select a date",
  }),
});

export type ResetUserTaxCaseFormValues = z.infer<typeof resetUserTaxCaseSchema>;
